import { observer } from 'mobx-react-lite';
import React from 'react';

import { IActivityModelInstance } from '@/hotel/models/activity.model';
import { useTranslation } from '@/i18n';

import { MoreInfoCardSection } from './MoreInfoCardSection.component';

interface ActivitiesCardProps {
  activities: IActivityModelInstance[];
  title?: string;
}

/**
 * @deprecated Use RestaurantsCardSection instead. Activities got merged into restaurants.
 */
export const ActivitiesCardSection = observer(
  ({ activities, title }: ActivitiesCardProps) => {
    const { t } = useTranslation('confirmation');

    return (
      <MoreInfoCardSection
        title={title ?? t('activities.sectionTitle')}
        items={activities.map((activity) => ({
          name: activity.name,
          description: activity.description,
          image: activity.images[0],
          url: activity.publicUrl,
        }))}
      />
    );
  }
);
